import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { NAV, CONTACT } from "../data";
import { useAppraisal } from "./AppraisalContext";
import { ArrowUpRight } from "lucide-react";

export const Footer = () => {
  const { openDialog } = useAppraisal();
  return (
    <footer className="bg-kept-ink text-kept-sand grain" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20">
        <div className="grid md:grid-cols-12 gap-12 border-b border-kept-sand/10 pb-16">
          <div className="md:col-span-5">
            <Logo light />
            <p className="font-serif text-3xl md:text-4xl font-light mt-8 leading-tight max-w-md">
              Your property deserves prestigious management.
            </p>
            <button
              onClick={openDialog}
              className="group inline-flex items-center gap-3 mt-8 bg-kept-brass text-kept-ink px-7 py-4 kept-label"
              data-testid="footer-book-appraisal"
            >
              Book Your Free Rental Appraisal
              <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
            </button>
          </div>

          <div className="md:col-span-3 md:col-start-8">
            <div className="kept-label text-kept-brass mb-6">Explore</div>
            <ul className="space-y-3">
              {NAV.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-kept-sand/70 hover:text-kept-sand transition-colors text-sm"
                    data-testid={`footer-nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="kept-label text-kept-brass mb-6">Contact</div>
            <ul className="space-y-3 text-sm text-kept-sand/70">
              <li><a href={`tel:${CONTACT.phone.replace(/\s/g, "")}`} className="hover:text-kept-sand" data-testid="footer-phone">{CONTACT.phone}</a></li>
              <li><a href={`mailto:${CONTACT.email}`} className="hover:text-kept-sand break-all" data-testid="footer-email">{CONTACT.email}</a></li>
              <li className="pt-2 text-kept-sand/50">{CONTACT.location}</li>
            </ul>
          </div>
        </div>
        <div className="flex flex-col md:flex-row justify-between gap-4 pt-8 text-xs text-kept-sand/40">
          <p>© {new Date().getFullYear()} Kept Property Management. New Zealand.</p>
          <p>Premium · Compliance-forward · Financially disciplined</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
